import { getPublicRouteUrl } from '@nackle/service-urls';

export const idURL = getPublicRouteUrl( 'ID_PROVIDER' );
export const rosterUrl = getPublicRouteUrl( 'ROSTER_PROXY' );
export const privacyDownloadUrl = `${ getPublicRouteUrl( 'PRIVACY_API_PUBLIC' ) }/services/v1/files/download`;
export const featuresUrl = getPublicRouteUrl( 'FEATURES_SERVICE' );
